// PreventiApp · SaaS App shell (app.preventiapp.com)
// Este archivo se carga SOLO cuando REACT_APP_STATIC_SITE !== 'true'.
// Contiene todas las rutas de la plataforma: login, admin, app móvil y sus
// dependencias (AuthContext, Supabase, Sprint 4). Al mantenerlo separado de
// App.js, el build estático (SiteGround) NO incluye estas dependencias en su
// bundle, ni inicializa el cliente de Supabase.

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@/lib/queryClient';

import MobileApp from '@/mobile/MobileApp';

import { AuthProvider } from '@/context/AuthContext';
import LoginScreen from '@/auth/LoginScreen';
import ResetPasswordScreen from '@/auth/ResetPasswordScreen';
import RequireAuth from '@/auth/RequireAuth';
import SmartHome from '@/auth/SmartHome';
import AdminLayout from '@/auth/AdminLayout';
import AdminHome from '@/auth/admin/AdminHome';
import AdminColegios from '@/auth/admin/AdminColegios';
import AdminUsuarios from '@/auth/admin/AdminUsuarios';
import AdminCursos from '@/auth/admin/AdminCursos';
import AdminObservaciones from '@/auth/admin/AdminObservaciones';
import AdminObservacionDetalle from '@/auth/admin/AdminObservacionDetalle';
import AdminSoporte from '@/auth/admin/AdminSoporte';
import AdminImport from '@/auth/AdminImport';

// Sprint 4 · Gate 4.3 — Dashboard
import DashboardLayout from '@/auth/admin/dashboard/DashboardLayout';
import DashboardOficial from '@/auth/admin/dashboard/DashboardOficial';
import DashboardInduccion from '@/auth/admin/dashboard/DashboardInduccion';
import CasosList from '@/auth/admin/dashboard/CasosList';
import CaseDetailPage from '@/auth/admin/dashboard/CaseDetailPage';

import LandingPage from '@/LandingPage';

export default function AppSaaS() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
        <Routes>
          {/* Raíz: SmartHome decide (admin → /admin, operativo → MobileApp).
              RequireAuth garantiza sesión activa antes de resolver el rol. */}
          <Route path="/" element={<RequireAuth><SmartHome /></RequireAuth>} />
          <Route path="/app-movil" element={<RequireAuth><MobileApp /></RequireAuth>} />
          {/* Sitio institucional accesible en /sitio (PÚBLICO, sin login) */}
          <Route path="/sitio" element={<LandingPage />} />

          <Route path="/login" element={<LoginScreen />} />
          <Route path="/auth/reset" element={<ResetPasswordScreen />} />

          <Route path="/admin" element={<RequireAuth><AdminLayout /></RequireAuth>}>
            <Route index element={<AdminHome />} />
            <Route path="colegios" element={<AdminColegios />} />
            <Route path="usuarios" element={<AdminUsuarios />} />
            <Route path="cursos" element={<AdminCursos />} />
            <Route path="observaciones" element={<AdminObservaciones />} />
            <Route path="observaciones/:id" element={<AdminObservacionDetalle />} />
            <Route path="soporte" element={<AdminSoporte />} />
            <Route path="import" element={<AdminImport />} />
          </Route>

          {/* Sprint 4 · Gate 4.3 — Dashboard institucional (rol-gated en backend) */}
          <Route path="/admin/dashboard" element={<RequireAuth><DashboardLayout /></RequireAuth>}>
            <Route index element={<DashboardOficial />} />
            <Route path="induccion" element={<DashboardInduccion />} />
            <Route path="casos" element={<CasosList />} />
            <Route path="casos/:id" element={<CaseDetailPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
    </QueryClientProvider>
  );
}
